// extracted by mini-css-extract-plugin
export default {"top":"HeaderTime_top__P7ZYB","box":"HeaderTime_box__GzMCW","addButton":"HeaderTime_addButton__-PLOX"};